import { Component, Inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { NeqDialogService } from "@sharedcommon/services/dialog.service";

@Component({
    templateUrl: './edition-popin.component.html',
})
export class NeqEditionPopinComponent {
    message: string;
    response: any;
    options: any;
    type: string;

    inputControl = new FormControl(null, [Validators.required]);

    private isEntity: boolean;
    private isReference: boolean;
    private isNutrient: boolean;

    constructor(
        private readonly dialogRef: MatDialogRef<NeqEditionPopinComponent>,
        private translate: TranslateService,
        private dialogService: NeqDialogService,
        @Inject(MAT_DIALOG_DATA) public data: {
            columnField: string,
            type: string,
            options: any // Option list for select or nutrient if it's for a nutrient
        }
    ) {
    }

    ngOnInit() {
        this.type = this.data.type;
        this.options = this.data.options;

        this.isEntity = this.data.columnField === "entityLabel";
        this.isReference = this.data.columnField === "referenceLabel";
        this.isNutrient = this.type === "input-nutrient";

        // Set message
        if (this.isNutrient) {
            this.message = this.translate.instant('label.user.rawmaterial.popin.multiEdit.nutrient', {param: this.options});
        } else {
            this.message = this.translate.instant('label.user.rawmaterial.popin.multiEdit.' + this.data.columnField);
        }
    }

    getTooltipErrorMessage() {
        const errors = this.inputControl.errors;

        if (errors?.required) {
            return this.translate.instant('error.common.field-required');
        }
    }

    /**
     * Check input and dispkay confirmation message
     * @param isAddToFollow  true if it must be had a the end of previous data
     */
    checkInput(isAddToFollow: boolean) {
        if(this.inputControl.valid) {
            this.dialogService.showConfirmation(this.translate.instant('label.user.rawmaterial.popin.multiEdit.confirmation'))
                .afterClosed().subscribe((result: boolean) => {
                    if (result)
                        this.dialogRef.close({response: this.response, isAddToFollow: isAddToFollow});
                });
            }
    }

    getDataSource = (searchTerm, _page) => {
        if (this.isEntity || this.isReference) {
          return Promise.resolve(this.options
            .filter(opt =>
              opt.code.includes(searchTerm) ||
              (
                (this.isEntity && opt.label.includes(searchTerm)) ||
                (this.isReference && opt.label.includes(searchTerm))
              ))
            .map(res => ({
              id: res.id,
              label: `${res.code} - ${this.isEntity ? res.name : res.label}`
            }))
            .sort((a, b) => a.label.localeCompare(b.label)));
        }
        return null;
    }

    /**
     * Set selected value to the response
     * @param event selected value
     */
    changeSelectedElement(event: any) {
        if (event) {
            const res = this.options.find(o => o.id == event.id);
            this.response = { id: res.id, label: `${res.code} - ${this.isEntity ? res.name : res.label}` };
            this.inputControl.setValue(this.response);
            this.inputControl.updateValueAndValidity();
        } else {
            this.inputControl.setValue(event);
            this.inputControl.markAsDirty();
        }

    }
}
